import styled from 'styled-components';
import { rgba } from 'polished';

export const Group = styled.div`
  width: 100%;
`;

export const Toggle = styled.button<{ color: string }>`
  display: block;
  width: 100%;
  background: none;
  border: 3px solid transparent;
  padding: 10px;
  border-radius: 5px;
  font-family: 'Sora', sans-serif;
  text-align: left;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.lightGrey};
  }

  div.wrapper {
    display: flex;
    align-items: center;
  }

  div.icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    margin-right: 10px;
    border-radius: 5px;
    background-color: ${({ color }) => rgba(color, 0.1)};

    svg {
      color: ${({ color }) => color};
    }
  }

  div.info {
    display: flex;
    flex: 1;
    flex-direction: column;

    header,
    footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    header strong {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.softBlack};
    }

    footer {
      margin-top: 8px;

      span {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 13px;
        color: ${({ theme }) => theme.colors.grey};
      }
    }
  }

  > div.progress-bar {
    width: calc(100% - 54px);
    margin: 8px 0 0 54px;
  }
`;
